export enum D365OperationMode {
    SwitchIn = 100000000,
    CambioProdotto = 100000001,
    CambioProdottoDelibera = 100000002,
    CambioProdottoRetroattivo = 100000003,
    CambioProdottoRetroattivoExNovo = 100000010,
    CambioProdottoRetroattivoAssetCessato = 100000011,
    Domiciliazione = 100000004,
    Cessazione = 100000005,
    CessazioneAmministrativa = 100000020,
    SwitchInConVoltura = 100000006,
    VolturaCambioFornitoreVip = 100000200,
    VolturaCambioFornitoreRecupero = 100000201,
    SwitchInAmmVip = 100000007,
    SwitchInAmmRecupero = 100000008,
    SwitchInAmmRipensamento = 100000009,
    Attivazione = 100000100,
    ProvisioningManuale = 100000101,
    AttivazioneAmmVIP = 100000102,
    AttivazioneAmmRecupero = 100000103,
    // ATTIVAZIONE COMPLESSA
    AttivazioneA01Old = 100000106, // ATTIVAZIONE CON ISTANZA (pre MA2507)
    AttivazioneA01 = 100001200, // ATTIVAZIONE PREPOSATO (MA2507+)
    AttivazioneN02 = 100000107, // ALLACCIO CON POSA E ATTIVAZIONE
    AttivazioneA40 = 100000104, // ATTIVAZIONE CON ACCERTAMENTO
    AttivazionePN1 = 100000105, // PREVENTIVO E ATTIVAZIONE

    // ATTIVAZIONE COMPLESSA AMMINISTRATIVA
    AttivazioneAmmA01Old = 100000110, // ATTIVAZIONE CON ISTANZA AMM
    AttivazioneAmmA01 = 100001201, // ATTIVAZIONE PREPOSATO AMM
    AttivazioneAmmN02 = 100000111, // ALLACCIO CON POSA E ATTIVAZIONE AMM
    AttivazioneAmmA40 = 100000108, // ATTIVAZIONE CON ACCERTAMENTO AMM
    AttivazioneAmmPN1 = 100000109, // PREVENTIVO E ATTIVAZIONE AMM
    // ATTIVAZIONE COMPLESSA VIP
    AttivazioneVipA01Old = 100000114, // ATTIVAZIONE CON ISTANZA VIP
    AttivazioneVipA01 = 100001202, // ATTIVAZIONE PREPOSATO VIP
    AttivazioneVipN02 = 100000115, // ALLACCIO CON POSA E ATTIVAZIONE VIP
    AttivazioneVipA40 = 100000112, // ATTIVAZIONE CON ACCERTAMENTO VIP
    AttivazioneVipPN1 = 100000113, // PREVENTIVO E ATTIVAZIONE VIP
    // ATTIVAZIONE COMPLESSA RECUPERO
    AttivazionePewAmmRecuperoA01 = 100001203,

    //SCONTI
    ScontoStandalone = 100000900,

    // VOLTURA
    Voltura = 100000300,
    VolturaAmmVip = 100000301,
    VolturaAmmSiProvisioning = 100000302,
    VolturaAmmNoProvisioning = 100000303,
    VolturaAmmIncorporazioneSocietaria = 100000304,
    // VT DROP3
    VariazioneAteco = 100000021,
    VariazioneTipologiaFornituraGas = 100000022,
    VariazioneIndirizzo = 100000023,
    AllineaTipologiaUtilizzoDistributore = 100000024,
    CambioTipologiaFornitura = 100000901,
    Aggrega = 100000400,
    Disaggrega = 100000401,

    // EXTRACOMMODITY
    Extracommodity = 100001100,
    CessazioneExtracommodity = 100001101,
    VariazioneAumentoPotenza = 100001102,

    AggiungiModificaPannello = 100001103,
    RimuoviPannello = 100001104,

    // CESSAZIONE BROADBAND
    BroadBandRecessoStandard = 300000000,
    BroadBandRecessoContestazione = 300000001,
    BroadBandRecessoDisconoscimento = 300000002,
    BroadBandRecessoRipensamento = 300000003,
    BroadBandRichiestaDisdetta = 300000004,
    BroadBandAnnullaDisdetta = 300000005,
    BroadBandCessazioneAmministrativa = 300000006,

    //BROADBAND
    BroadNuovaAttivazione = 100001106,
    BroadMigrazione = 100001107,
    BroadBandCambioProdotto = 100001204,
    BroadBandVariazioneTecnica = 100001205
}
